<div class="dropdown-menu-end profile-card p-2 py-3">
  <div class="profile-header mb-3">
    <div class="avatar-circle me-2">
      {{ getInitials() }}
    </div>
    <div class="profile-info">
      <div class="profile-name">
        {{ profileService.profile?.firstname }} {{ profileService.profile?.lastname }}
      </div>
      <div class="profile-email text-muted">
        {{ profileService.profile?.email }}
      </div>
      <div class="profile-role text-muted">
        {{ profileService.isPartner ? (profileService.isOwner ? 'Owner' : 'Member') : (profileService.profile?.role | titlecase) }}
      </div>
      <div *ngIf="profileService.profile?.role === 'PARTNER' && profileService.profile?.partner?.name"
        class="profile-partner text-muted">
        {{ profileService.profile?.partner?.name }}
      </div>
    </div>
  </div>

  <hr *ngIf="isApprovedPartner() || canManageAccountSettings()" class="dropdown-divider" />

  <div class="menu-items">
    <button *ngIf="isApprovedOwner()" class="menu-item" (click)="navigateToProfile()">
      <div class="menu-icon">
        <i class="ti ti-user"></i>
      </div>
      <span>{{ 'Clinic Details' | translate }}</span>
    </button>

    <button *ngIf="isApprovedOwner()" class="menu-item" (click)="openSubscriptions()">
      <div class="menu-icon">
        <i class="ti ti-credit-card"></i>
      </div>
      <span>{{ 'Subscriptions' | translate }}</span>
    </button>

    <button *ngIf="canManageAccountSettings()" class="menu-item" (click)="navigateToSettings()">
      <div class="menu-icon">
        <i class="ti ti-settings"></i>
      </div>
      <span>{{ 'Settings' | translate }}</span>
    </button>
  </div>

  <hr class="dropdown-divider" />

  <button class="menu-item menu-item-danger" (click)="logout()">
    <div class="menu-icon menu-icon-danger">
      <i class="ti ti-logout"></i>
    </div>
    <span>{{ 'Logout' | translate }}</span>
  </button>
</div>
